/** Banner de fuente: ok / unconnected / error / demo. */
export default function SourceBanner({ mode = 'unconnected', children, message }) {
  const m = String(mode || 'unconnected');
  if (m === 'ok' && !children && !message) {
    return null;
  }

  const className =
    'analytics-source-banner' +
    (m === 'demo' ? ' is-demo' : '') +
    (m === 'ok' ? ' is-ok' : '') +
    (m === 'error' ? ' is-error' : '') +
    (m === 'unconnected' ? ' is-unconnected' : '');

  let body = children;
  if (!body) {
    if (m === 'demo') {
      body = (
        <>
          <strong>Datos de demostración.</strong> No representan operación real.
        </>
      );
    } else if (m === 'ok') {
      body = message ? (
        <>
          <strong>Fuente conectada.</strong> {message}
        </>
      ) : null;
    } else if (m === 'error') {
      body = (
        <>
          <strong>Error al leer la fuente.</strong>{' '}
          {message || 'Revisá la configuración o reintentá.'}
        </>
      );
    } else {
      body = (
        <>
          <strong>Fuente no conectada.</strong>{' '}
          {message ||
            'Este módulo mostrará indicadores cuando la integración esté configurada en analytics-api.'}
        </>
      );
    }
  }

  if (!body) return null;

  return (
    <div className={className} role="status">
      {body}
    </div>
  );
}
